/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface ITenantApi {
    getTenantSettings(cancelToken?: CancelToken): AxiosPromise<TenantSettingsModel>;
    updateTenantSettings(updateTenantSettingsRequest: UpdateTenantSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void>;
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_TenantApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_TenantApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class TenantApi implements ITenantApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_TenantApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_TenantApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getTenantSettings(cancelToken?: CancelToken): AxiosPromise<TenantSettingsModel> {
        let url_ = "/marketing/api/brands/Tenant/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<TenantSettingsModel>(options_);
    }

    updateTenantSettings(updateTenantSettingsRequest: UpdateTenantSettingsRequest, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/marketing/api/brands/Tenant/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = updateTenantSettingsRequest;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }
}

export interface TenantSettingsModel {
    optOutProperties?: OptOutProperties | undefined;
    doubleOptInProperties?: DoubleOptInProperties | undefined;
    emailValidationProperties?: EmailValidationProperties | undefined;
}

export interface OptOutProperties {
    enabled?: boolean | undefined;
    subjectLine?: string | undefined;
    header?: string | undefined;
    body?: string | undefined;
    buttonText?: string | undefined;
    unopenedEmailsMinimum?: number | undefined;
    monthsLimit?: number | undefined;
    autoSuppressionEnabled?: boolean | undefined;
}

export interface DoubleOptInProperties {
    enabled?: boolean | undefined;
    emailSubject?: string | undefined;
    emailHeader?: string | undefined;
    emailBody?: string | undefined;
    emailButtonText?: string | undefined;
}

export interface EmailValidationProperties {
    validationLevel: EmailValidationLevel;
}

export enum EmailValidationLevel {
    NoValidation = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export interface UpdateTenantSettingsRequest {
    tenantSettings: TenantSettingsModel;
}
